"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invisibilityCloak = _interopRequireDefault(require("../../../invisibility-cloak/invisibility-cloak"));

var _videoStates = _interopRequireDefault(require("../video-states"));

var _videoControls = require("../video-controls.effect");

var _usePrevious = require("../../../hooks/use-previous/use-previous");

const PLAYING = _videoStates.default.PLAYING;
const HIDE_AFTER_MS = 3000;

const ControlsCloak = props => {
  const {
    videoTag
  } = props;
  const {
    status
  } = (0, _videoControls.useVideoStatus)(videoTag);
  const prevStatus = (0, _usePrevious.usePrevious)(status);
  const statusRef = (0, _react.useRef)(status);
  const timer = (0, _react.useRef)(null);
  const uncoverTimer = (0, _react.useRef)(null);
  const [isCovered, setCover] = (0, _react.useState)(false);
  const isCoveredRef = (0, _react.useRef)(isCovered);
  (0, _react.useEffect)(() => {
    isCoveredRef.current = isCovered;
    statusRef.current = status;
  });
  const parentElement = videoTag.parentElement.parentElement; // cleanup on unmount

  (0, _react.useEffect)(() => () => {
    clearTimeout(timer.current);
    clearTimeout(uncoverTimer.current);
    parentElement.removeEventListener('mousemove', onMouseMove);
    parentElement.removeEventListener('mouseleave', onMouseLeave);
  }, []);

  function cover() {
    parentElement.addEventListener('mousemove', onMouseMove);
    setCover(true);
  }

  function uncover() {
    parentElement.removeEventListener('mousemove', onMouseMove);
    setCover(false);
  }

  function coverIfPlaying() {
    if (statusRef.current === PLAYING && !isCoveredRef.current) {
      cover();
    }
  } // wasn't playing, now playing


  if (prevStatus !== PLAYING && status === PLAYING) {
    renewCoverTimer();
  } else if (prevStatus === PLAYING && status !== PLAYING) {
    // stopped playing
    uncoverTimer.current = setTimeout(uncover);
    clearCoverTimer();
  }

  function renewCoverTimer() {
    clearCoverTimer();
    timer.current = setTimeout(coverIfPlaying, HIDE_AFTER_MS);
  }

  function clearCoverTimer() {
    clearTimeout(timer.current);
    timer.current = null;
  } // mouse move


  function onMouseMove() {
    if (isCoveredRef.current) {
      onInteraction();
      parentElement.addEventListener('mouseleave', onMouseLeave);
    }
  }

  function onMouseLeave() {
    coverIfPlaying(); // TODO only do this when the first timer is already gone

    parentElement.removeEventListener('mouseleave', onMouseLeave);
  } // reset timers based on last interaction time


  const {
    lastInteraction
  } = props;
  const prevLastInteraction = (0, _usePrevious.usePrevious)(lastInteraction);

  if (lastInteraction !== prevLastInteraction) {
    onInteraction();
  }

  function onInteraction() {
    uncoverTimer.current = setTimeout(uncover);
    renewCoverTimer();
  }

  return /*#__PURE__*/_react.default.createElement(_invisibilityCloak.default, (0, _extends2.default)({
    covered: isCovered,
    stretch: true
  }, props));
};

ControlsCloak.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element),
  lastInteraction: _propTypes.default.instanceOf(Date)
};
ControlsCloak.defaultProps = {
  videoTag: undefined,
  lastInteraction: null
};
var _default = ControlsCloak;
exports.default = _default;